/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowGroupFitnessChallengeTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowGroupFitnessChallenge,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Get Fit Together!",
    "Group Fitness Challenge Awaits!",
    "Fitness Fun for Everyone!",
  ],
  title: "Group Fitness Challenge",
  description: "Organize a fun group fitness challenge.",
  longDescription:
    "Gather your friends for an exciting group fitness challenge! Choose a date, decide on activities, and plan refreshments!",
  emoji: "💪",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Group Fitness Challenge",
          emoji: "💪",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the group fitness challenge?",
          emoji: "📅",
          completeAction: {
            question: "Decide on fitness activities?",
            description:
              "What activities should we focus on during the challenge?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we consider?",
                emoji: "🏋",
                completeAction: {
                  question: "Decide on refreshments?",
                  description: "What refreshments should we plan for the day?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🥤",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Get Fit Together!",
    outroDescription:
      "Your group fitness challenge plans are set! Enjoy the fun!",
  },
};
